import { styled } from '../../styled-components';

// {
//   simple?: boolean;
//   inline?: boolean;
// }
export const EmptyStateIconStyled = styled.div.attrs({ className: '' })`
  opacity: 0.5;
`;
